import { PATHS } from "@/config/path";
import { rootStore } from "@/store/RootStore";

export function getManagementPath() {
  const { isBrandAccess, isGroupAccess, isBranchAccess } = rootStore.authStore;

  if (isGroupAccess) return PATHS.RESTAURANT.GROUP.ROOT;
  if (isBrandAccess) return PATHS.RESTAURANT.BRAND.ROOT;
  if (isBranchAccess)
    return PATHS.RESTAURANT.BRANCH.BUSINESS_MANAGEMENT_DETAILS;
  return "";
}
